import { ChangeEvent, FunctionComponent } from 'react';
import { MenuProps } from './MenuProps';

export const Menu: FunctionComponent<MenuProps> = ({ className, items, disabledItem, defaultValue, onChange }) => {
  function didSelectItem(event: ChangeEvent<HTMLSelectElement>): void {
    onChange(event.target.value);
  }

  return (
    <select
      className={className ? className : 'w-full py-1 bg-bg-tertiary rounded-lg box-border'}
      defaultValue={defaultValue}
      onChange={didSelectItem}
    >
      {disabledItem ? (
        <option disabled value={'undefined'}>
          {disabledItem}
        </option>
      ) : undefined}
      {items.map((item) => (
        <option key={item.id} value={item.id}>
          {item.item}
        </option>
      ))}
    </select>
  );
};
